import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";
import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

class ImportClassroomAttendanceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: false,
            message: ""
        };
    }

    handleFileChange = (e) => {
        const { component } = this.props;
        const file = e.target.files[0];

        // Atualiza o estado do componente pai (IntegrationsMain)
        component.setState({
            form: { ...component.state.form, classroomAttendanceFile: file }
        });
    };

    render() {
        const { show, onClose, onSubmit, component } = this.props;
        const { loading, error, message } = this.state;
        const { form } = component.state;

        // Só habilita o botão se houver um arquivo selecionado
        const hasFile = form?.classroomAttendanceFile !== undefined;

        return (
            <Modal size="lg" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Importação de Frequência Diária</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading === true && <PageLoadingIndicator loadingText={"Processando arquivo..."} />}
                    {error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}

                    <div className="form mt-2">
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label>Selecione o arquivo CSV (.csv)</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".csv"
                                onChange={this.handleFileChange}
                                disabled={loading}
                            />
                            <Form.Text muted>
                                O arquivo deve conter as colunas de Matrícula, Data/Hora e Tipo de Evento.
                            </Form.Text>
                        </Form.Group>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <Button
                        disabled={loading || !hasFile}
                        variant="success"
                        onClick={onSubmit}
                    >
                        Enviar para Processamento
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
}

export default ImportClassroomAttendanceModal;